import { DeleteConfirmationModalContainer } from "../../../modals/DeleteConfirmationModal/DeleteConfirmationModalContainer";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { JSX } from "react";
import { setIsDeleteScheduledQualificationModalOpen } from "../ScheduledQualificationsSlice";
import { handleDeleteScheduledQualification } from "../utils/handleDeleteScheduledQualification";

interface Props {
    deleteScheduledQualification: (params: { id: string }) => {
        unwrap: () => Promise<unknown>;
    };
    isDeleteScheduledQualificationLoading: boolean;
}

export const DeleteScheduledQualificationModal = (
    props: Props,
): JSX.Element | null => {
    const {
        deleteScheduledQualification,
        isDeleteScheduledQualificationLoading,
    } = props;
    const {
        isDeleteScheduledQualificationModalOpen,
        scheduledQualificationId,
    } = useAppSelector((state) => state.scheduledQualifications);
    const dispatch = useAppDispatch();

    if (!isDeleteScheduledQualificationModalOpen) {
        return null;
    }

    return (
        <DeleteConfirmationModalContainer
            title={"Ingeplande kwalificatie verwijderen"}
            text={
                "Weet je zeker dat je deze ingeplande kwalificatie wilt verwijderen?"
            }
            onCloseButtonText={"Terug naar overzicht"}
            onConfirmationButtonText={"Verwijder"}
            onConfirmationButtonIsLoading={
                isDeleteScheduledQualificationLoading
            }
            onCloseClick={() =>
                dispatch(setIsDeleteScheduledQualificationModalOpen(false))
            }
            onConfirmationClick={() =>
                handleDeleteScheduledQualification({
                    id: scheduledQualificationId,
                    deleteScheduledQualification,
                    dispatch,
                })
            }
        />
    );
};
